import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MyPagination from "../common/MyPagination";
import { Box } from "@mui/material";
import CellImage from "../common/CellImage";
import { asyncRequest } from "src/services/network";

function Products({ onSelect }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/store/product/short",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  function handleItemCLick(row) {
    onSelect(`StoreProductDetail?id=${row.id}`);
  }

  const handlePageChange = (event, value) => {
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  return (
    <Box sx={{ flex: 1, overflow: "auto" }}>
      <TableContainer>
        <Table sx={{ minWidth: 500 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">名称</TableCell>
              <TableCell align="left">预览图</TableCell>
              <TableCell align="left">价格</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((row) => (
              <TableRow key={row.id} sx={{ "&:last-child td, &:last-child th": { border: 0 }, cursor: "pointer" }} onClick={() => handleItemCLick(row)}>
                <TableCell align="left">{row.name}</TableCell>
                <TableCell align="left">
                  <CellImage src={row.cover} />
                </TableCell>
                <TableCell align="left">{row.price}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
    </Box>
  );
}

export default Products;
